module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path == '/acountManage/formatAgent') ? _c('div', [_c('div', {
    staticClass: "agent-poor"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('div', {
    staticClass: "search-switch",
    style: (_vm.bgStyle)
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_vm._v("高级搜索\n                    "), _c('i', {
    staticClass: "el-icon--right",
    class: _vm.arrowClass
  })])], 1)], 1), _vm._v(" "), _c('complex-search', {
    ref: "complexSearch",
    on: {
      "search": _vm.complexSearch,
      "reset": _vm.resetFilterData
    },
    model: {
      value: (_vm.searchVisiable),
      callback: function($$v) {
        _vm.searchVisiable = $$v
      },
      expression: "searchVisiable"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.selectRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CustomerId",
      "label": "ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AgentCode",
      "label": "客户编号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CustomerName",
      "label": "公司",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Name",
      "label": "主联系人",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Tel",
      "label": "主联系人电话",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Tel",
      "label": "客户电话",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProjectTypeNames",
      "label": "所属项目",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Account",
      "label": "代理商账号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Provinces",
      "label": "省份",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "City",
      "label": "城市",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Area",
      "label": "地区",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "所属业务经理",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PassTime",
      "label": "转正时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "opt-templ"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showDetails(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.viewAgentArea(scope.row)
            }
          }
        }, [_vm._v("代理区域")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('viewDialog', {
    ref: "viewDialog"
  }), _vm._v(" "), _c('edit-dialog', {
    ref: "updateDialog",
    on: {
      "reload-list": _vm.getList
    }
  }), _vm._v(" "), _c('agent-area', {
    ref: "refAgentArea"
  }), _vm._v(" "), _c('child-account', {
    ref: "accountChild",
    attrs: {
      "AgentId": _vm.agentId
    }
  }), _vm._v(" "), _c('add-agent', {
    ref: "applyZzDialog",
    on: {
      "reload-list": _vm.getList
    },
    model: {
      value: (_vm.addDialogVisiable),
      callback: function($$v) {
        _vm.addDialogVisiable = $$v
      },
      expression: "addDialogVisiable"
    }
  })], 1) : _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ee07d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/CRMFormatAgent/index.vue
// module id = 1531
// module chunks = 1